// Helpers for the bell dropdown's All/Mentions tabs (notifications.js).

const FILTERS = ["all", "mentions"];

// The All/Mentions tab currently shown in the bell dropdown's frame
// (notifications/_filter_tabs marks it aria-current="page").
export function activeNotificationFilter(frame) {
  const tab = frame?.querySelector?.("[data-notification-filter][aria-current='page']");
  const key = tab?.dataset?.notificationFilter;
  return FILTERS.includes(key) ? key : "all";
}

// "?filter=mentions" for the Mentions tab, nothing for All; the same scoping
// as the notifications page's own "Mark all as read" link.
export function withNotificationFilter(path, filter) {
  return filter === "mentions" ? `${path}?filter=mentions` : path;
}
